/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * fuel object
 * @export
 * @interface GetCorporationsCorporationIdStarbasesStarbaseIdFuel
 */
export interface GetCorporationsCorporationIdStarbasesStarbaseIdFuel {
    /**
     * quantity integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdStarbasesStarbaseIdFuel
     */
    quantity: number;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetCorporationsCorporationIdStarbasesStarbaseIdFuel
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdStarbasesStarbaseIdFuel interface.
 */
export function instanceOfGetCorporationsCorporationIdStarbasesStarbaseIdFuel(value: object): value is GetCorporationsCorporationIdStarbasesStarbaseIdFuel {
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdStarbasesStarbaseIdFuelFromJSON(json: any): GetCorporationsCorporationIdStarbasesStarbaseIdFuel {
    return GetCorporationsCorporationIdStarbasesStarbaseIdFuelFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdStarbasesStarbaseIdFuelFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdStarbasesStarbaseIdFuel {
    if (json == null) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
        'typeId': json['type_id'],
    };
}

export function GetCorporationsCorporationIdStarbasesStarbaseIdFuelToJSON(json: any): GetCorporationsCorporationIdStarbasesStarbaseIdFuel {
    return GetCorporationsCorporationIdStarbasesStarbaseIdFuelToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdStarbasesStarbaseIdFuelToJSONTyped(value?: GetCorporationsCorporationIdStarbasesStarbaseIdFuel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quantity': value['quantity'],
        'type_id': value['typeId'],
    };
}

